

import http from '../http.js';

// 邮箱认证
export async function checkEmailKey(params) {
    const res = await http({
        method: 'get',
        url: `/hbsdweb/authenticate/emailVerity`,
        params
    });
    return res;
}

// 邮箱认证
export async function submitCertificatesEmail(params) {
    const res = await http({
        method: 'post',
        url: `/hbsdweb/authenticate/sendEmail`,
        params
    });
    return res;
}
